'use client'
import { useState, useEffect } from 'react'
import { FaSearch, FaFilter , FaHome, FaBuilding } from 'react-icons/fa'
import { MdSell, MdVilla } from 'react-icons/md'
import { FaShop } from "react-icons/fa6";
import { AiFillLayout } from 'react-icons/ai'
import Link from 'next/link'
import tailwindConfig from '@tailwind.config'
import HeroSearchBts from '@components/Search/HeroSearchBts'
import LinkComponent from '@components/LinkComponent'
import { searchTypes } from '@constants/searchTypes';
import { saleTypes } from '@constants/saleTypes';
import { RadioGroup } from '@headlessui/react'
import { Combobox, Listbox } from "@headlessui/react"
import { RiArrowDropDownLine } from 'react-icons/ri'
import { categoryTypes } from '@constants/homeCategoryTypes';
import { homeRoomTypes } from '@constants/homeRoomTypes';
import { saleMaxPrices } from '@constants/saleMaxPrice'
import { saleMinPrices } from '@constants/saleMinPrice'
import { rentMaxPrices } from '@constants/rentMaxPrice'
import { rentMinPrices } from '@constants/rentMinPrice'


const FrontSearchBar = ({ slogan, districtList, dictionary, lang }) => {
    const [sale, setSale] = useState(saleTypes[lang][0])
    // console.log(districtList)

    const [selectedCategory, setSelectedCategory] = useState([categoryTypes[lang]?.[0]])
    const [selectedDistrict, setSelectedDistrict] = useState([districtList?.[0]] || [])
    const [bedrooms, setBedrooms] = useState(homeRoomTypes?.[lang]?.[0])
    const [minPrice, setMinPrice] = useState(saleMinPrices[lang][0])
    const [maxPrice, setMaxPrice] = useState(saleMaxPrices[lang][0])
    const [name, setName] = useState('')
    
    const [filterOpen, setFilterOpen] = useState(false)
    
    const [categoryQuery, setCategoryQuery] = useState('')
    const [districtQuery, setDistrictQuery] = useState('')
    const [bedroomsQuery, setBedroomsQuery] = useState('')
    const [minpriceQuery, setMinpriceQuery] = useState('')
    const [maxpriceQuery, setMaxpriceQuery] = useState('')
    
    const toggleCategories = (e) => {
        // console.log(e)
        let newCategoryArray = []
        let newCategoryQueryArray = []
        if (e.length > 0) {
            e.forEach(element => {
                if (element.value !== 'all') {
                    newCategoryArray.push(element)
                    newCategoryQueryArray.push(element.value)
                }
            });
        } else {
            newCategoryArray.push(categoryTypes[lang][0])
            newCategoryQueryArray = []
        }

        setSelectedCategory(newCategoryArray)
        // console.log(newCategoryQueryArray)
        const newCategoryString = newCategoryQueryArray.toString().toLowerCase().replaceAll(',', '%2C')
        if (newCategoryQueryArray.length > 0) {
            setCategoryQuery(`&categories=${newCategoryString}`)
        } else {
            setCategoryQuery('')
        }
    }
    const toggleDistricts = (e) => {
        // console.log(e)
        let newArray = []
        let newQueryArray = []
        if (e.length > 0) {
            e.forEach(element => {
                if (element.id !== 'all') {
                    newArray.push(element)
                    newQueryArray.push(element.id)
                }
            });
        } else {
            newArray.push(districtList[0])
            newQueryArray = []
        }

        setSelectedDistrict(newArray)
        // console.log(newCategoryQueryArray)
        const newString = newQueryArray.toString().toLowerCase().replaceAll(',', '%2C')
        if (newQueryArray.length > 0) {
            setDistrictQuery(`&districts=${newString}`)
        } else {
            setDistrictQuery('')
        }
    }

    const handleBedroomUpdate = (e) => {
        // console.log(e)
        setBedrooms(e)
        if (e.value !== '0') {
            setBedroomsQuery(`&room=${e.value}`)
        } else {
            setBedroomsQuery('')
        }
    }

    useEffect(() => {
        // console.log(sale)
        if (sale.value == 'rent') {
            setMinPrice(rentMinPrices[lang][0])
            setMaxPrice(rentMaxPrices[lang][0])
        } else {
            setMinPrice(saleMinPrices[lang][0])
            setMaxPrice(saleMaxPrices[lang][0])
        }
        setMinpriceQuery('')
        setMaxpriceQuery('')
    }, [sale])
    

    const handleMinPriceQuery = (e) => {
        // console.log(e)
        if (e.value !== '0') {
            setMinpriceQuery(`&minprice=${e.value}`)
            setMinPrice(e)
        } else {
            setMinpriceQuery('')
            setMinPrice('')
        }
    }

    const handleMaxPriceQuery = (e) => {
        // console.log(e)
        if (e.value !== '') {
            setMaxpriceQuery(`&maxprice=${e.value}`)
            setMaxPrice(e)
        } else {
            setMaxpriceQuery('')
            setMaxPrice('')
        }
    }

    return (
        <div className='sm:animate-slide-in-bottom absolute w-full z-50 sm:bottom-[200px] bottom-1/3 flex flex-col justify-center items-center'>
            <div className='mb-5'>
                <h1 className='text-light md:text-[60px] text-xl font-bold'>{slogan?.[lang] ? slogan[lang] : ''}</h1>
            </div>
            <div className={`sm:mt-10 mt-5 relative  shadow-sm shadow-black rounded-md`}>
                <div className={`flex sm:flex-row flex-col ${filterOpen ? 'rounded-t-md bg-maincolor' : 'rounded-md'} overflow-hidden`}>
                    <Listbox className={`${!!name ? '!text-gray-400' : ''}`} disabled={!!name} value={sale} onChange={setSale}>
                        <div className='z-1 sm:w-[200px] w-[320px] cursor-default rounded-t-lg sm:rounded-t-none sm:rounded-l-lg bg-white text-left border-[1px] border-forth text-secondary sm:text-sm'>
                            <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left sm:text-sm">
                                <span className="block truncate">{sale.title}</span>
                                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                    <RiArrowDropDownLine
                                        color={!!name ? 'gray' : tailwindConfig.theme.extend.colors.secondary}
                                        size={28}
                                    />
                                </span>
                            </Listbox.Button>
                                <Listbox.Options className="absolute mt-1 max-h-60 sm:w-[200px] w-[320px] overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50">
                                    {saleTypes[lang].map((cont, contIdx) => (
                                        <Listbox.Option
                                            key={contIdx}
                                            className={({ active }) =>
                                                `relative cursor-default select-none py-2 pl-4 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                                }`
                                            }
                                            value={cont}
                                        >
                                            {({ selected }) => (
                                                <>
                                                    <span
                                                        className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                            }`}
                                                    >
                                                        {cont.title}
                                                    </span>
                                                    {selected ? (
                                                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                        </span>
                                                    ) : null}
                                                </>
                                            )}
                                        </Listbox.Option>
                                    ))}
                                </Listbox.Options>
                        </div>
                    </Listbox>
                    <Listbox className={`${!!name ? '!text-gray-400' : ''}`} disabled={!!name} value={selectedCategory} onChange={toggleCategories} multiple>
                        <div className='z-1 sm:w-[200px] w-[320px] cursor-default bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                            <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left sm:text-sm">
                                <span className="block truncate">{selectedCategory.map((category) => category.title).join(', ')}</span>
                                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                    <RiArrowDropDownLine
                                        color={!!name ? 'gray' : tailwindConfig.theme.extend.colors.secondary}
                                        size={28}
                                    />
                                </span>
                            </Listbox.Button>
                            <Listbox.Options className="absolute mt-1 max-h-60 sm:w-[200px] w-[320px] overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50">
                                {categoryTypes[lang].map((cont, contIdx) => (
                                    <Listbox.Option
                                        key={contIdx}
                                        className={({ active }) =>
                                            `relative cursor-default select-none py-2 pl-3 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                            }`
                                        }
                                        value={cont}
                                    >
                                        {({ selected }) => (
                                            <>
                                                <span
                                                    className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                        }`}
                                                >
                                                    {cont.title}
                                                </span>
                                                {selected ? (
                                                    <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                        {/* <CheckIcon className="h-5 w-5" aria-hidden="true" /> */}
                                                    </span>
                                                ) : null}
                                            </>
                                        )}
                                    </Listbox.Option>
                                ))}
                            </Listbox.Options>
                        </div>
                    </Listbox>
                    <Listbox className={`${!!name ? '!text-gray-400' : ''}`} disabled={!!name} value={selectedDistrict} onChange={toggleDistricts} multiple>
                        <div className='z-1 sm:w-[200px] w-[320px] cursor-default bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                            <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left sm:text-sm">
                                <span className="block truncate">{selectedDistrict && selectedDistrict?.map((dist) => dist.subdistrict).join(', ')}</span>
                                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                    <RiArrowDropDownLine
                                        color={!!name ? 'gray' : tailwindConfig.theme.extend.colors.secondary}
                                        size={28}
                                    />
                                </span>
                            </Listbox.Button>
                            <Listbox.Options className="absolute mt-1 max-h-[180px] sm:w-[200px] w-[320px] overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50">
                                {districtList.map((cont, contIdx) => (
                                    <Listbox.Option
                                        key={contIdx}
                                        className={({ active }) =>
                                            `relative cursor-default select-none py-2 pl-3 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                            }`
                                        }
                                        value={cont}
                                    >
                                        {({ selected }) => (
                                            <>
                                                <span
                                                    className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                        }`}
                                                >
                                                    {cont.subdistrict} {cont.location ? `${(cont.location)}` : ''}
                                                </span>
                                                {selected ? (
                                                    <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                        {/* <CheckIcon className="h-5 w-5" aria-hidden="true" /> */}
                                                    </span>
                                                ) : null}
                                            </>
                                        )}
                                    </Listbox.Option>
                                ))}
                            </Listbox.Options>
                        </div>
                    </Listbox>
                    <div className='sm:hidden flex'>
                            {sale.value == 'sale' && (
                                <Listbox className={`${!!name ? '!text-gray-400' : ''}`} disabled={!!name} value={minPrice} onChange={handleMinPriceQuery}>
                                    <div className='z-1 w-1/2 cursor-default bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                        <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left sm:text-sm">
                                            <span className="block truncate">{minPrice.nom}</span>
                                            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                <RiArrowDropDownLine
                                                    color={!!name ? 'gray' : tailwindConfig.theme.extend.colors.secondary}
                                                    size={28}
                                                />
                                            </span>
                                        </Listbox.Button>
                                        <Listbox.Options className="absolute mt-1 max-h-[120px] w-1/2 overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50">
                                            {saleMinPrices[lang].map((cont, contIdx) => (
                                                <Listbox.Option
                                                    key={contIdx}
                                                    className={({ active }) =>
                                                        `relative cursor-default select-none py-2 pl-3 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                                        }`
                                                    }
                                                    value={cont}
                                                >
                                                    {({ selected }) => (
                                                        <>
                                                            <span
                                                                className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                    }`}
                                                            >
                                                                {cont.nom}
                                                            </span>
                                                            {selected ? (
                                                                <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                                </span>
                                                            ) : null}
                                                        </>
                                                    )}
                                                </Listbox.Option>
                                            ))}
                                        </Listbox.Options>
                                    </div>
                                </Listbox>
                            )}
                            {sale.value == 'sale' && (
                                <Listbox className={`${!!name ? '!text-gray-400' : ''}`} disabled={!!name} value={maxPrice} onChange={handleMaxPriceQuery}>
                                    <div className='z-1  w-1/2 cursor-default bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                        <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left sm:text-sm">
                                            <span className="block truncate">{maxPrice.nom}</span>
                                            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                <RiArrowDropDownLine
                                                    color={!!name ? 'gray' : tailwindConfig.theme.extend.colors.secondary}
                                                    size={28}
                                                />
                                            </span>
                                        </Listbox.Button>
                                        <Listbox.Options className="absolute mt-1 max-h-[120px] w-1/2 overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50">
                                            {saleMaxPrices[lang].map((cont, contIdx) => (
                                                <Listbox.Option
                                                    key={contIdx}
                                                    className={({ active }) =>
                                                        `relative cursor-default select-none py-2 pl-3 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                                        }`
                                                    }
                                                    value={cont}
                                                >
                                                    {({ selected }) => (
                                                        <>
                                                            <span
                                                                className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                    }`}
                                                            >
                                                                {cont.nom}
                                                            </span>
                                                            {selected ? (
                                                                <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                                </span>
                                                            ) : null}
                                                        </>
                                                    )}
                                                </Listbox.Option>
                                            ))}
                                        </Listbox.Options>
                                    </div>
                                </Listbox>
                            )}
                            {sale.value == 'rent' && (
                                <Listbox className={`${!!name ? '!text-gray-400' : ''}`} disabled={!!name} value={minPrice} onChange={handleMinPriceQuery}>
                                    <div className='z-1  w-1/2 cursor-default bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                        <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left sm:text-sm">
                                            <span className="block truncate">{minPrice.nom}</span>
                                            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                <RiArrowDropDownLine
                                                    color={!!name ? 'gray' : tailwindConfig.theme.extend.colors.secondary}
                                                    size={28}
                                                />
                                            </span>
                                        </Listbox.Button>
                                        <Listbox.Options className="absolute mt-1 max-h-[120px]  w-1/2 overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50">
                                            {rentMinPrices[lang].map((cont, contIdx) => (
                                                <Listbox.Option
                                                    key={contIdx}
                                                    className={({ active }) =>
                                                        `relative cursor-default select-none py-2 pl-3 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                                        }`
                                                    }
                                                    value={cont}
                                                >
                                                    {({ selected }) => (
                                                        <>
                                                            <span
                                                                className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                    }`}
                                                            >
                                                                {cont.nom}
                                                            </span>
                                                            {selected ? (
                                                                <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                                </span>
                                                            ) : null}
                                                        </>
                                                    )}
                                                </Listbox.Option>
                                            ))}
                                        </Listbox.Options>
                                    </div>
                                </Listbox>
                            )}
                            {sale.value == 'rent' && (
                                <Listbox className={`${!!name ? '!text-gray-400' : ''}`} disabled={!!name} value={maxPrice} onChange={handleMaxPriceQuery}>
                                    <div className='z-1  w-1/2 cursor-default bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                        <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left sm:text-sm">
                                            <span className="block truncate">{maxPrice.nom}</span>
                                            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                <RiArrowDropDownLine
                                                    color={!!name ? 'gray' : tailwindConfig.theme.extend.colors.secondary}
                                                    size={28}
                                                />
                                            </span>
                                        </Listbox.Button>
                                        <Listbox.Options className="absolute mt-1 max-h-[120px]  w-1/2 overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50">
                                            {rentMaxPrices[lang].map((cont, contIdx) => (
                                                <Listbox.Option
                                                    key={contIdx}
                                                    className={({ active }) =>
                                                        `relative cursor-default select-none py-2 pl-3 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                                        }`
                                                    }
                                                    value={cont}
                                                >
                                                    {({ selected }) => (
                                                        <>
                                                            <span
                                                                className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                    }`}
                                                            >
                                                                {cont.nom}
                                                            </span>
                                                            {selected ? (
                                                                <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                                </span>
                                                            ) : null}
                                                        </>
                                                    )}
                                                </Listbox.Option>
                                            ))}
                                        </Listbox.Options>
                                    </div>
                                </Listbox>
                            )}
                    </div>
                    {filterOpen && (
                        <div className='sm:hidden flex w-full sm:flex-row flex-col p-0 sm:p-1'>
                            <Listbox className={`${!!name ? '!text-gray-400' : ''}`} disabled={!!name} value={bedrooms} onChange={handleBedroomUpdate}>
                                <div className='z-1 sm:w-[200px] w-[320px] cursor-default rounded-none sm:rounded-l-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                    <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left sm:text-sm">
                                        <span className="block truncate">{bedrooms.title}</span>
                                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                            <RiArrowDropDownLine
                                                color={!!name ? 'gray' : tailwindConfig.theme.extend.colors.secondary}
                                                size={28}
                                            />
                                        </span>
                                    </Listbox.Button>
                                    <Listbox.Options className="absolute mt-1 max-h-[120px] sm:w-[200px] w-[320px] overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50">
                                        {homeRoomTypes[lang].map((cont, contIdx) => (
                                            <Listbox.Option
                                                key={contIdx}
                                                className={({ active }) =>
                                                    `relative cursor-default select-none py-2 pl-3 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                                    }`
                                                }
                                                value={cont}
                                            >
                                                {({ selected }) => (
                                                    <>
                                                        <span
                                                            className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                }`}
                                                        >
                                                            {cont.title}
                                                        </span>
                                                        {selected ? (
                                                            <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                            </span>
                                                        ) : null}
                                                    </>
                                                )}
                                            </Listbox.Option>
                                        ))}
                                    </Listbox.Options>
                                </div>
                            </Listbox>
                            {/* {sale.value == 'sale' && (
                                <Listbox className={`${!!name ? '!text-gray-400' : ''}`} disabled={!!name} value={minPrice} onChange={handleMinPriceQuery}>
                                    <div className='z-1 sm:w-[200px] w-[320px] cursor-default bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                        <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left sm:text-sm">
                                            <span className="block truncate">{minPrice.nom}</span>
                                            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                <RiArrowDropDownLine
                                                    color={!!name ? 'gray' : tailwindConfig.theme.extend.colors.secondary}
                                                    size={28}
                                                />
                                            </span>
                                        </Listbox.Button>
                                        <Listbox.Options className="absolute mt-1 max-h-[120px] sm:w-[200px] w-[320px] overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50">
                                            {saleMinPrices[lang].map((cont, contIdx) => (
                                                <Listbox.Option
                                                    key={contIdx}
                                                    className={({ active }) =>
                                                        `relative cursor-default select-none py-2 pl-3 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                                        }`
                                                    }
                                                    value={cont}
                                                >
                                                    {({ selected }) => (
                                                        <>
                                                            <span
                                                                className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                    }`}
                                                            >
                                                                {cont.nom}
                                                            </span>
                                                            {selected ? (
                                                                <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                                </span>
                                                            ) : null}
                                                        </>
                                                    )}
                                                </Listbox.Option>
                                            ))}
                                        </Listbox.Options>
                                    </div>
                                </Listbox>
                            )}
                            {sale.value == 'rent' && (
                                <Listbox className={`${!!name ? '!text-gray-400' : ''}`} disabled={!!name} value={minPrice} onChange={handleMinPriceQuery}>
                                    <div className='z-1 sm:w-[200px] w-[320px] cursor-default bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                        <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left sm:text-sm">
                                            <span className="block truncate">{minPrice.nom}</span>
                                            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                <RiArrowDropDownLine
                                                    color={!!name ? 'gray' : tailwindConfig.theme.extend.colors.secondary}
                                                    size={28}
                                                />
                                            </span>
                                        </Listbox.Button>
                                        <Listbox.Options className="absolute mt-1 max-h-[120px] sm:w-[200px] w-[320px] overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50">
                                            {rentMinPrices[lang].map((cont, contIdx) => (
                                                <Listbox.Option
                                                    key={contIdx}
                                                    className={({ active }) =>
                                                        `relative cursor-default select-none py-2 pl-3 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                                        }`
                                                    }
                                                    value={cont}
                                                >
                                                    {({ selected }) => (
                                                        <>
                                                            <span
                                                                className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                    }`}
                                                            >
                                                                {cont.nom}
                                                            </span>
                                                            {selected ? (
                                                                <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                                </span>
                                                            ) : null}
                                                        </>
                                                    )}
                                                </Listbox.Option>
                                            ))}
                                        </Listbox.Options>
                                    </div>
                                </Listbox>
                            )}
                            {sale.value == 'sale' && (
                                <Listbox className={`${!!name ? '!text-gray-400' : ''}`} disabled={!!name} value={maxPrice} onChange={handleMaxPriceQuery}>
                                    <div className='z-1 sm:w-[200px] w-[320px] cursor-default bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                        <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left sm:text-sm">
                                            <span className="block truncate">{maxPrice.nom}</span>
                                            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                <RiArrowDropDownLine
                                                    color={!!name ? 'gray' : tailwindConfig.theme.extend.colors.secondary}
                                                    size={28}
                                                />
                                            </span>
                                        </Listbox.Button>
                                        <Listbox.Options className="absolute mt-1 max-h-[120px] sm:w-[200px] w-[320px] overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50">
                                            {saleMaxPrices[lang].map((cont, contIdx) => (
                                                <Listbox.Option
                                                    key={contIdx}
                                                    className={({ active }) =>
                                                        `relative cursor-default select-none py-2 pl-3 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                                        }`
                                                    }
                                                    value={cont}
                                                >
                                                    {({ selected }) => (
                                                        <>
                                                            <span
                                                                className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                    }`}
                                                            >
                                                                {cont.nom}
                                                            </span>
                                                            {selected ? (
                                                                <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                                </span>
                                                            ) : null}
                                                        </>
                                                    )}
                                                </Listbox.Option>
                                            ))}
                                        </Listbox.Options>
                                    </div>
                                </Listbox>
                            )}
                            {sale.value == 'rent' && (
                                <Listbox className={`${!!name ? '!text-gray-400' : ''}`} disabled={!!name} value={maxPrice} onChange={handleMaxPriceQuery}>
                                    <div className='z-1 sm:w-[200px] w-[320px] cursor-default bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                        <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left sm:text-sm">
                                            <span className="block truncate">{maxPrice.nom}</span>
                                            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                <RiArrowDropDownLine
                                                    color={!!name ? 'gray' : tailwindConfig.theme.extend.colors.secondary}
                                                    size={28}
                                                />
                                            </span>
                                        </Listbox.Button>
                                        <Listbox.Options className="absolute mt-1 max-h-[120px] sm:w-[200px] w-[320px] overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50">
                                            {rentMaxPrices[lang].map((cont, contIdx) => (
                                                <Listbox.Option
                                                    key={contIdx}
                                                    className={({ active }) =>
                                                        `relative cursor-default select-none py-2 pl-3 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                                        }`
                                                    }
                                                    value={cont}
                                                >
                                                    {({ selected }) => (
                                                        <>
                                                            <span
                                                                className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                    }`}
                                                            >
                                                                {cont.nom}
                                                            </span>
                                                            {selected ? (
                                                                <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                                </span>
                                                            ) : null}
                                                        </>
                                                    )}
                                                </Listbox.Option>
                                            ))}
                                        </Listbox.Options>
                                    </div>
                                </Listbox>
                            )} */}
                            <div className="relative h-full sm:w-[200px] w-[320px]">
                                <input
                                    onChange={(e) => setName(e.target.value)}
                                    value={name}
                                    placeholder={`${dictionary.refIdOrName}`}
                                    className="pl-3 py-2 pr-2 rounded:none sm:rounded-r-md w-full focus:outline-none"
                                />
                                {name && (
                                    <button
                                    type="button"
                                    onClick={() => setName("")}
                                    className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                                    >
                                    ✕
                                    </button>
                                )}
                            </div>
                        </div>
                    )}
                    <div className='sm:w-[200px] w-[320px] flex flex-row'>
                        <div onClick={() => {setFilterOpen(prev => !prev)}} className='w-[150px] flex flex-grow items-center justify-center bg-maincolor hover:bg-secondary text-white cursor-pointer'>
                            <div className='flex gap-3 items-center justify-center py-2'>
                                <FaFilter size={16} />
                                <span>{filterOpen ? `${dictionary.lessFilters}` : `${dictionary.moreFilters}`}</span>
                            </div>
                        </div>
                        {!!name ? (
                            <div className='sm:block hidden w-[50px] bg-white sm:rounded-r-lg rounded-tr-none rounded-br-md'>
                                <Link
                                    href={`/properties?name=${name}`}
                                    className='bg-third hover:bg-maincolor sm:rounded-r-lg rounded-tr-none rounded-br-md h-full w-full px-4 py-2 hover:shadow-md transition-colors duration-300 text-light  rounded-r-md text-xl flex items-center' 
                                ><FaSearch size={24} /></Link>
                            </div>
                        ) : (
                            <div className='sm:block hidden w-[50px] bg-white sm:rounded-r-lg rounded-tr-none rounded-br-md'>
                                <Link
                                    href={`/properties?saleType=${sale.value}${categoryQuery}${districtQuery}${bedroomsQuery}${minpriceQuery}${maxpriceQuery}`}
                                    className='bg-third hover:bg-maincolor sm:rounded-r-lg rounded-tr-none rounded-br-md h-full w-full px-4 py-2 hover:shadow-md transition-colors duration-300 text-light  rounded-r-md text-xl flex items-center'
                                ><FaSearch size={24} /></Link>
                            </div>
                        )}
                    </div>
                    <div className='sm:hidden block rounded-b-md overflow-hidden'>
                        {!!name ? (
                            <div className='w-[320px] bg-white sm:rounded-r-lg rounded-tr-none rounded-br-md'>
                                <Link
                                    href={`/properties?name=${name}`}
                                    className='flex items-center gap-3 justify-center bg-third hover:bg-maincolor sm:rounded-r-lg rounded-tr-none rounded-br-md h-full w-full px-4 py-2 hover:shadow-md transition-colors duration-300 text-light  rounded-b-md '
                                >
                                    <FaSearch size={24} />
                                    <span>{dictionary.search}</span>
                                </Link>
                            </div>
                        ) : (
                            <div className='w-[320px] bg-white sm:rounded-r-lg rounded-tr-none rounded-br-md'>
                                <Link
                                    href={`/properties?saleType=${sale.value}${categoryQuery}${districtQuery}${bedroomsQuery}${minpriceQuery}${maxpriceQuery}`}
                                    className='flex items-center gap-3 justify-center bg-third hover:bg-maincolor sm:rounded-r-lg rounded-tr-none rounded-br-md h-full w-full px-4 py-2 hover:shadow-md transition-colors duration-300 text-light  rounded-b-md'
                                >
                                    <FaSearch size={24} />
                                    <span>{dictionary.search}</span>
                                </Link>
                            </div>
                        )}

                    </div>
                </div>
                <div className={`absolute rounded-b-md w-full pt-2 bg-maincolor ${filterOpen ? 'hidden sm:block' : 'hidden'}`}>
                    <div className='w-full flex sm:flex-row flex-col p-0 sm:p-1'>
                        <Listbox className={`${!!name ? '!text-gray-400' : ''}`} disabled={!!name} value={bedrooms} onChange={handleBedroomUpdate}>
                            <div className='z-1 sm:w-[197px] w-[320px] cursor-default rounded-none sm:rounded-l-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left sm:text-sm">
                                    <span className="block truncate">{bedrooms.title}</span>
                                    <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                        <RiArrowDropDownLine
                                            color={!!name ? 'gray' : tailwindConfig.theme.extend.colors.secondary}
                                            size={28}
                                        />
                                    </span>
                                </Listbox.Button>
                                <Listbox.Options className="absolute mt-1 max-h-[120px] sm:w-[200px] w-[320px] overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50">
                                    {homeRoomTypes[lang].map((cont, contIdx) => (
                                        <Listbox.Option
                                            key={contIdx}
                                            className={({ active }) =>
                                                `relative cursor-default select-none py-2 pl-3 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                                }`
                                            }
                                            value={cont}
                                        >
                                            {({ selected }) => (
                                                <>
                                                    <span
                                                        className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                            }`}
                                                    >
                                                        {cont.title}
                                                    </span>
                                                    {selected ? (
                                                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                        </span>
                                                    ) : null}
                                                </>
                                            )}
                                        </Listbox.Option>
                                    ))}
                                </Listbox.Options>
                            </div>
                        </Listbox>
                        {sale.value == 'sale' && (
                            <Listbox className={`${!!name ? '!text-gray-400' : ''}`} disabled={!!name} value={minPrice} onChange={handleMinPriceQuery}>
                                <div className='z-1 sm:w-[203px] w-[320px] cursor-default bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                    <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left sm:text-sm">
                                        <span className="block truncate">{minPrice.nom}</span>
                                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                            <RiArrowDropDownLine
                                                color={!!name ? 'gray' : tailwindConfig.theme.extend.colors.secondary}
                                                size={28}
                                            />
                                        </span>
                                    </Listbox.Button>
                                    <Listbox.Options className="absolute mt-1 max-h-[120px] sm:w-[200px] w-[320px] overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50">
                                        {saleMinPrices[lang].map((cont, contIdx) => (
                                            <Listbox.Option
                                                key={contIdx}
                                                className={({ active }) =>
                                                    `relative cursor-default select-none py-2 pl-3 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                                    }`
                                                }
                                                value={cont}
                                            >
                                                {({ selected }) => (
                                                    <>
                                                        <span
                                                            className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                }`}
                                                        >
                                                            {cont.nom}
                                                        </span>
                                                        {selected ? (
                                                            <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                            </span>
                                                        ) : null}
                                                    </>
                                                )}
                                            </Listbox.Option>
                                        ))}
                                    </Listbox.Options>
                                </div>
                            </Listbox>
                        )}
                        {sale.value == 'rent' && (
                            <Listbox className={`${!!name ? '!text-gray-400' : ''}`} disabled={!!name} value={minPrice} onChange={handleMinPriceQuery}>
                                <div className='z-1 sm:w-[203px] w-[320px] cursor-default bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                    <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left sm:text-sm">
                                        <span className="block truncate">{minPrice.nom}</span>
                                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                            <RiArrowDropDownLine
                                                color={!!name ? 'gray' : tailwindConfig.theme.extend.colors.secondary}
                                                size={28}
                                            />
                                        </span>
                                    </Listbox.Button>
                                    <Listbox.Options className="absolute mt-1 max-h-[120px] sm:w-[200px] w-[320px] overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50">
                                        {rentMinPrices[lang].map((cont, contIdx) => (
                                            <Listbox.Option
                                                key={contIdx}
                                                className={({ active }) =>
                                                    `relative cursor-default select-none py-2 pl-3 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                                    }`
                                                }
                                                value={cont}
                                            >
                                                {({ selected }) => (
                                                    <>
                                                        <span
                                                            className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                }`}
                                                        >
                                                            {cont.nom}
                                                        </span>
                                                        {selected ? (
                                                            <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                            </span>
                                                        ) : null}
                                                    </>
                                                )}
                                            </Listbox.Option>
                                        ))}
                                    </Listbox.Options>
                                </div>
                            </Listbox>
                        )}
                        {sale.value == 'sale' && (
                            <Listbox className={`${!!name ? '!text-gray-400' : ''}`} disabled={!!name} value={maxPrice} onChange={handleMaxPriceQuery}>
                                <div className='z-1 sm:w-[205px] w-[320px] cursor-default bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                    <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left sm:text-sm">
                                        <span className="block truncate">{maxPrice.nom}</span>
                                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                            <RiArrowDropDownLine
                                                color={!!name ? 'gray' : tailwindConfig.theme.extend.colors.secondary}
                                                size={28}
                                            />
                                        </span>
                                    </Listbox.Button>
                                    <Listbox.Options className="absolute mt-1 max-h-[120px] sm:w-[200px] w-[320px] overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50">
                                        {saleMaxPrices[lang].map((cont, contIdx) => (
                                            <Listbox.Option
                                                key={contIdx}
                                                className={({ active }) =>
                                                    `relative cursor-default select-none py-2 pl-3 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                                    }`
                                                }
                                                value={cont}
                                            >
                                                {({ selected }) => (
                                                    <>
                                                        <span
                                                            className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                }`}
                                                        >
                                                            {cont.nom}
                                                        </span>
                                                        {selected ? (
                                                            <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                            </span>
                                                        ) : null}
                                                    </>
                                                )}
                                            </Listbox.Option>
                                        ))}
                                    </Listbox.Options>
                                </div>
                            </Listbox>
                        )}
                        {sale.value == 'rent' && (
                            <Listbox className={`${!!name ? '!text-gray-400' : ''}`} disabled={!!name} value={maxPrice} onChange={handleMaxPriceQuery}>
                                <div className='z-1 sm:w-[205px] w-[320px] cursor-default bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                    <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left sm:text-sm">
                                        <span className="block truncate">{maxPrice.nom}</span>
                                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                            <RiArrowDropDownLine
                                                color={!!name ? 'gray' : tailwindConfig.theme.extend.colors.secondary}
                                                size={28}
                                            />
                                        </span>
                                    </Listbox.Button>
                                    <Listbox.Options className="absolute mt-1 max-h-[120px] sm:w-[200px] w-[320px] overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50">
                                        {rentMaxPrices[lang].map((cont, contIdx) => (
                                            <Listbox.Option
                                                key={contIdx}
                                                className={({ active }) =>
                                                    `relative cursor-default select-none py-2 pl-3 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                                    }`
                                                }
                                                value={cont}
                                            >
                                                {({ selected }) => (
                                                    <>
                                                        <span
                                                            className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                }`}
                                                        >
                                                            {cont.nom}
                                                        </span>
                                                        {selected ? (
                                                            <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                            </span>
                                                        ) : null}
                                                    </>
                                                )}
                                            </Listbox.Option>
                                        ))}
                                    </Listbox.Options>
                                </div>
                            </Listbox>
                        )}
                        <div className="relative h-full sm:w-[200px] w-[320px]">
                            <input
                                onChange={(e) => setName(e.target.value)}
                                value={name}
                                placeholder={`${dictionary.refIdOrName}`}
                                className="pl-3 py-2 pr-2 rounded:none sm:rounded-r-md w-full focus:outline-none"
                            />
                            {name && (
                                <button
                                type="button"
                                onClick={() => setName("")}
                                className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                                >
                                ✕
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
           
        </div>
    )
}

export default FrontSearchBar